// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"31":"GalleryView","32":"HomeView","283":"ProductsView","705":"ContactsView"}[chunkId] + "." + {"31":"3059bb19","32":"bb394ed3","283":"44a75e9f","705":"76c5ef92"}[chunkId] + ".css";
};